import { render, staticRenderFns } from "./BgMenu.vue?vue&type=template&id=7ea6b214&scoped=true"
import script from "./BgMenu.vue?vue&type=script&lang=js"
export * from "./BgMenu.vue?vue&type=script&lang=js"
import style0 from "./BgMenu.vue?vue&type=style&index=0&id=7ea6b214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea6b214",
  null
  
)

export default component.exports